import { PureComponent } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import TimetoastPropTypes from '../../../../constants/timetoast_prop_types'
import MultiImage from '@components/MultiImage'
import Image from '../../../../components/Image'
import FloatingModal from '../../../../components/modals/FloatingModal'
export default class TimelineItemImage extends PureComponent {
  constructor(props) {
    super(props)
    this.$portalTarget = null
    this.state = {
      modalOpen: false,
    }
  }

  // stores the portal target if it can be found, or creates a new div and sets it as the target
  setupPortalTarget() {
    if (!this.$portalTarget) {
      this.$portalTarget = document.querySelector('#js-timeline-item-modal-target')
      if (!this.$portalTarget) {
        this.$portalTarget = document.createElement('div')
        document.body.appendChild(this.$portalTarget)
      }
    }
  }

  handleClick = event => {
    this.toggleModalVisibility()
  }

  handleCloseModal = event => {
    this.toggleModalVisibility()
  }

  toggleModalVisibility() {
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  getModalContent() {
    const { modalImageData, enableModalViewing } = this.props
    const { modalOpen } = this.state
    if (enableModalViewing && modalOpen) {
      let modalContent = null
      if (modalImageData !== undefined) {
        // Sometimes the particular derivative isn't available and modalImageData is undefined
        const imgStyle = {
          width: '100%',
          height: 'auto',
          display: 'block',
        }
        modalContent = (
          <Image
            src={modalImageData.src}
            width={modalImageData.width}
            height={modalImageData.height}
            style={imgStyle}
          />
        )
      } else {
        modalContent = <p>Sorry, this image is unavailable.</p>
      }
      const content = (
        <FloatingModal show={modalOpen} onClose={this.handleCloseModal} firstChildAsHeader={false}>
          {modalContent}
        </FloatingModal>
      )
      this.setupPortalTarget()
      return createPortal(content, this.$portalTarget)
    }
    return null
  }

  render() {
    const { imageData, containerWidth, containerHeight, zIndex, enableModalViewing } = this.props

    const imageStyle = {
      zIndex,
      cursor: enableModalViewing ? 'pointer' : 'inherit',
    }
    const onClick = enableModalViewing ? this.handleClick : null
    const modal = this.getModalContent()
    return (
      <div className="tooltip-main-image-container" style={imageStyle} onClick={onClick}>
        <MultiImage
          imgSrc={imageData.src}
          imgWidth={imageData.width}
          imgHeight={imageData.height}
          containerWidth={containerWidth}
          containerHeight={containerHeight}
        />
        {modal}
      </div>
    )
  }
}

TimelineItemImage.propTypes = {
  imageData: TimetoastPropTypes.image,
  modalImageData: TimetoastPropTypes.image,
  containerWidth: PropTypes.number,
  containerHeight: PropTypes.number,
  zIndex: PropTypes.number,
  enableModalViewing: PropTypes.bool,
}
